import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./view-location-building-list-directive.html';
import styles from './ViewLocationBuildingList-hashed.scss';
import startAddBuildingWizardFlow from '../../AddBuildingWizard/flow';

export default [function () {
    return {
        restrict: 'E',
        scope: {
            location: '='
        },
        template: cssUtil.hashTemplate(template, styles),
        controller: ['$scope', '$injector', function ($scope, $injector) {
            $scope.sortType = 'description';
            $scope.sortReverse = false;

            $scope.$watch('location', function (value) {
                $scope.buildingList = value.buildings;
            });

            $scope.addBuilding = function () {
                startAddBuildingWizardFlow($injector, { selectedLocation: $scope.location });
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/directives/cp-view-location-building-list-directive/ViewLocationBuildingListDirective.js
// module id = 1000
// module chunks = 0